import { ReactElement, useEffect } from "react";

import { triggerSnowplowImpressionEvent } from "@themuse/snowplow-js-client";
import { useInView } from "react-intersection-observer";

import { NewsletterCardModule } from "./NewsletterCardModule";

interface NewsletterCardModuleProps {
    formViewed?: boolean;
    changeToFormViewed?: () => void;
}

export const NewsletterCard = (props: NewsletterCardModuleProps): ReactElement => {
    const { formViewed, changeToFormViewed } = props;
    const formView = useInView({ triggerOnce: true, rootMargin: "0px" });
    const successView = useInView({ triggerOnce: true, rootMargin: "0px" });

    useEffect(() => {
        if (formView.inView && !formViewed) {
            triggerSnowplowImpressionEvent(formView.entry.target as HTMLElement);
            changeToFormViewed();
        }
    }, [formView.inView]);

    useEffect(() => {
        if (successView.inView) {
            triggerSnowplowImpressionEvent(successView.entry.target as HTMLElement);
        }
    }, [successView.inView]);

    return (
        <NewsletterCardModule
            formRef={formView.ref}
            successRef={successView.ref}
        />
    );
};
